import React, { useEffect, useId, useState } from 'react';
import './Navbar.css';
import fullLogo from "../../../assets/images/APISVG.svg";
import { Link, NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const menuId = useId();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMenuOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') setIsMenuOpen(false);
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isMenuOpen]);

  return (
    <header className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={fullLogo} alt="Logo" />
        </Link>

        <button
          type="button"
          className={`navbar-toggle ${isMenuOpen ? 'navbar-toggle--open' : ''}`}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          aria-controls={menuId}
          onClick={() => setIsMenuOpen((v) => !v)}
        >
          <span className="navbar-toggle-icon" aria-hidden="true">
            <span className="navbar-toggle-bar" />
            <span className="navbar-toggle-bar" />
            <span className="navbar-toggle-bar" />
          </span>
        </button>

        <nav
          id={menuId}
          className={`navbar-menu ${isMenuOpen ? 'navbar-menu--open' : ''}`}
        >
          <NavLink
            to="/"
            end
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            HOME
          </NavLink>
          <NavLink
            to="/about"
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            ABOUT US
          </NavLink>
          <NavLink
            to="/manufacture"
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            MANUFACTURING LINES
          </NavLink>
          <NavLink
            to="/partnership"
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            PARTNERSHIP
          </NavLink>
          <NavLink
            to="/contact"
            onClick={() => setIsMenuOpen(false)}
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            CONTACT
          </NavLink>
        </nav>
      </div>

      <div
        className={`navbar-backdrop ${isMenuOpen ? 'navbar-backdrop--open' : ''}`}
        aria-hidden="true"
        onClick={() => setIsMenuOpen(false)}
      />
    </header>
  );
};

export default Navbar;